export default __webpack_public_path__ + "static/media/1.fcc6789c.png";